import { Navigate } from 'react-router';

import { LoadingScreen } from '@components/LoadingScreen';

import { DEFAULT_REDIRECT_URL } from './paths';
import { useMe } from '@hooks/useMe';

const getDefaultRedirectRoute = (roles: string[]) => {
  if (roles.includes('Admin') && !roles.includes('Mailroom')) {
    return DEFAULT_REDIRECT_URL.users;
  }

  if (roles.includes('Mailroom') || roles.includes('KTAdmin') || roles.includes('Admin'))
    return DEFAULT_REDIRECT_URL.mailroom;

  if (roles.includes('Recipient')) return DEFAULT_REDIRECT_URL.recipient;

  return DEFAULT_REDIRECT_URL.default;
};

export const DefaultRecirect = () => {
  const { currentUser } = useMe();

  if (currentUser) {
    const { roles } = currentUser;

    const route = getDefaultRedirectRoute(roles);

    return <Navigate to={route} replace />;
  }

  // return <Navigate to="auth/login" replace />;
  return <LoadingScreen />;
};
